import React from 'react';
import { Badge } from 'react-bootstrap';

const HEAD_CHURCH_LABEL = 'Head Church';
const HEAD_CHURCH_BADGE_BG = 'secondary-subtle';
const HEAD_CHURCH_BADGE_CLASS = 'ntcog-head-church-badge';
const HEAD_CHURCH_BADGE_CLASS_NAME =
  `${HEAD_CHURCH_BADGE_CLASS} ms-2 align-middle text-nowrap fw-normal text-muted fw-semibold border border-secondary-subtle`;

/**
 * Shared Head Church badge: secondary-subtle fill, muted text, description-scale
 * (rem-pinned so list body text and My Church h1 parents cannot change size).
 */
const HeadChurchLabel: React.FC = () => (
  <Badge
    bg={HEAD_CHURCH_BADGE_BG}
    className={HEAD_CHURCH_BADGE_CLASS_NAME}
    data-testid="head-church-label"
  >
    {HEAD_CHURCH_LABEL}
  </Badge>
);

export default HeadChurchLabel;
